import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail, ArrowRight } from "lucide-react";

export default function AffiliateApplySuccess() {
    const [params] = useSearchParams();
    const id = params.get("id");
    return (
        <div
            className="min-h-screen bg-cream flex flex-col"
            data-testid="affiliate-apply-success"
        >
            <header className="px-6 lg:px-12 py-6">
                <Link to="/" className="font-display text-2xl text-navy-700">
                    Perx <span className="text-gold-600">Group</span>
                </Link>
            </header>
            <main className="flex-1 px-6 lg:px-12 pb-20 flex items-center">
                <div className="max-w-2xl mx-auto w-full bg-white rounded-3xl border border-navy-100 shadow-[0_20px_80px_rgba(0,28,80,0.08)] p-10 text-center">
                    <div className="mx-auto h-14 w-14 rounded-full bg-emerald-50 flex items-center justify-center">
                        <CheckCircle2 className="text-emerald-600" size={28} />
                    </div>
                    <h1 className="font-display text-4xl text-navy-700 mt-6 leading-tight">
                        Application received.
                    </h1>
                    <p className="text-navy-500 mt-4 text-base leading-relaxed max-w-md mx-auto">
                        Thanks for applying to become a Perx affiliate. Our brand team
                        reviews every submission by hand — expect a decision by email
                        within <span className="text-navy-700 font-semibold">3-5 business days</span>.
                    </p>
                    {id && (
                        <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-cream border border-navy-100 px-3 py-1.5 text-[11px] font-mono tracking-widest text-navy-500">
                            Reference: {id.slice(0, 8).toUpperCase()}
                        </div>
                    )}
                    <div className="mt-8 rounded-2xl bg-cream border border-gold-200/60 p-5 text-left">
                        <div className="flex items-center gap-2 text-navy-700 font-semibold text-sm">
                            <Mail size={14} className="text-gold-600" />
                            What happens next
                        </div>
                        <ul className="mt-3 text-sm text-navy-500 space-y-1.5 list-disc list-inside">
                            <li>We&rsquo;ll review your social profiles and recent content.</li>
                            <li>
                                If approved, you&rsquo;ll receive a welcome email with a
                                secure link to set your password.
                            </li>
                            <li>
                                Once logged in you&rsquo;ll unlock your affiliate dashboard,
                                referral link generator, QR code, and discount codes.
                            </li>
                        </ul>
                    </div>
                    <Link to="/">
                        <Button
                            data-testid="apply-success-home"
                            className="mt-8 rounded-full bg-navy-700 hover:bg-navy-800 text-cream h-11 px-8"
                        >
                            Back to Perx
                            <ArrowRight size={14} className="ml-2" />
                        </Button>
                    </Link>
                </div>
            </main>
        </div>
    );
}
